import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadHypertrackerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00033 10.6667L4.66699 7.33334L5.60033 6.36667L7.33366 8.10001V2.66667H8.66699V8.10001L10.4003 6.36667L11.3337 7.33334L8.00033 10.6667ZM4.00033 13.3333C3.63366 13.3333 3.31988 13.2029 3.05899 12.942C2.7981 12.6811 2.66744 12.3671 2.66699 12V10H4.00033V12H12.0003V10H13.3337V12C13.3337 12.3667 13.2032 12.6807 12.9423 12.942C12.6814 13.2033 12.3674 13.3338 12.0003 13.3333H4.00033Z",
		fill: "white"
	})
});
export default SvgDownloadHypertrackerIcon;
